/**
 * Bricht zu lange Berufsbezeichnungen mittels HTML-Umbruchzeichen auf und fügt ein soft hyphen vor "(in)" ein.
 * Gedacht für Angebotstitel.
 */
export function breakTitle(word: string): string {
  const regex = /(<[^>]+>|<\/[^>]+>)|\/+|\(in\)/g;
  let insideElement = false;
  return word.replace(regex, (match, group1) => {
    if (group1) {
      insideElement = !insideElement;
      return match;
    }

    if (insideElement) {
      return breakTitle(match);
    }

    switch (match) {
      case '/':
        return '/<wbr>';
      case '(in)':
        return '&shy;(in)';
      default:
        return match;
    }
  });
}
